var map = {
	"./": 402,
	"./doctor": 904,
	"./doctor.tsx": 904,
	"./guest": 906,
	"./guest.tsx": 906,
	"./index": 402,
	"./index.ts": 402,
	"./patient": 905,
	"./patient.tsx": 905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1195;